/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';

// function BottomSheetCard({
//   isOpen, onClose, title, children, initialHeight, pageName
// }) {
//   const [height, setHeight] = useState(initialHeight); // Initial height of the bottom sheet
//   const sheetRef = useRef();
//   useEffect(() => {
//     // console.log('hello init ', height)
//     // isOpen = true;
//   }, [height]);
//   const handleTouchEvent = (event) => {
//     if (event.type === 'touchmove') {
//       const screenHeight = window.innerHeight;
//       const touchY = event.touches[0].clientY;
//       const newHeight = ((screenHeight - touchY) / screenHeight) * 100;

//       // Restrict height between 30% and 70%
//       if (newHeight > 70) {
//         setHeight('100%');
//       } else if (newHeight >= 30 && newHeight <= 70) {
//         setHeight(`${newHeight}%`);
//       }
//     } else if (event.type === 'touchend') {
//       // Snap to either 30% or 70% based on current height
//       const currentHeight = parseFloat(height);
//       if (currentHeight > 70) {
//         setHeight('100%');
//       } else if (currentHeight >= 35 && currentHeight <= 70) {
//         setHeight('60%');
//       } else {
//         // console.log('less than 30')
//         setHeight('0%');
//         onClose();
//       }
//     }
//   };
//   return (
//     <div
//       className={`fixed inset-0 z-50 transition-all ${isOpen ? 'pointer-events-auto' : 'pointer-events-none'
//       } lg:hidden `}
//     >
//       {/* Overlay */}
//       {/* fixed inset-0 bg-black bg-opacity-50 transition-opacity opacity-100 */}
//       <div
//         className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0'
//         }`}
//         onClick={onClose}
//         aria-hidden="true"
//       />

//       {/* Bottom Sheet */}
//       <div
//         ref={sheetRef}
//         className="absolute bottom-0 left-0 right-0 bg-white rounded-t-lg shadow-lg overflow-hidden flex flex-col transform transition-transform"
//         style={{ height }}
//         onTouchMove={handleTouchEvent}
//         onTouchEnd={handleTouchEvent}
//       >
//         {/* Drag Handle */}
//         <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mt-2 cursor-pointer" />

//         {/* Title */}
//         <div className="p-4 border-b flex justify-between items-center" style={{ borderColor: '#939393' }}>
//           <h2 className="2xl:text-lg xl:text-base md:text-base text-base font-semibold text-gray-800">{title}</h2>
//         </div>

//         {/* Content */}
//         <div className="flex-1 overflow-y-auto">{children}</div>
//         <div className="p-4 border-t border-gray-200 flex justify-between md:justify-center items-center" style={{ borderColor: '#939393' }}>
//           ddds
//         </div>
//       </div>
//     </div>
//   );
// }

/* eslint-disable */
// import React, { useState, useRef, useEffect } from "react";
import PropTypes from 'prop-types';

const BottomSheetCard = ({ isOpen, onClose, title, children, clearFilter, applyFilters, pageName, initialHeight }) => {
  const [height, setHeight] = useState(initialHeight); // Initial height of the bottom sheet
  const sheetRef = useRef();
  useEffect(() => {
    // console.log('hello init ', height)
  }, [height]);
  const handleTouchEvent = (event) => {
    if (event.type === "touchmove") {
      const screenHeight = window.innerHeight;
      const touchY = event.touches[0].clientY;
      const newHeight = ((screenHeight - touchY) / screenHeight) * 100;

      // Restrict height between 30% and 70%
      if (newHeight > 70) {
        setHeight(`100%`);
      } else if (newHeight >= 30 && newHeight <= 70) {
        setHeight(`${newHeight}%`);
      }
    } 
    else if (event.type === "touchend") {
      // Snap to either 30% or 70% based on current height
      const currentHeight = parseFloat(height);
      if (currentHeight > 70) {
        setHeight(`100%`);
      } else if (currentHeight >= 35 && currentHeight <= 70) {
        setHeight(initialHeight);
      }
      else {
        // console.log('less than 30')
        setHeight("0%");
        onClose();
      }
    }
  };

  return (
    <div
      className={`fixed inset-0 z-50 transition-all ${isOpen ? "pointer-events-auto" : "pointer-events-none"
        } lg:hidden `}
    >
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity ${isOpen ? "opacity-100" : "opacity-0"
          }`}
        onClick={onClose}
        aria-hidden="true"
      ></div>

      {/* Bottom Sheet */}
      <div
        ref={sheetRef}
        className={`absolute bottom-0 left-0 right-0 bg-white rounded-t-lg shadow-lg overflow-hidden flex flex-col transform transition-transform`}
        style={{ height: height }}
        onTouchMove={handleTouchEvent}
        onTouchEnd={handleTouchEvent}
      >
        {/* Drag Handle */}
        <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mt-2 cursor-pointer"></div>

        {/* Title */}
        <div className="p-4 border-b flex justify-between items-center border-thinBlue">
          <h2 className="2xl:text-lg xl:text-base md:text-base text-base font-semibold text-gray-800">{title}</h2>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};

BottomSheetCard.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  // Children: PropTypes.object.isRequired,
  clearFilter: PropTypes.func.isRequired,
  applyFilters: PropTypes.func.isRequired,
};
export default BottomSheetCard;
